import { User } from '@/models/auth';
import { Booking, CreateBooking } from '@/models/bookings';
import { Header } from '@/models/state';
import { State } from './state';

export const MUTATIONS = {
  SET_API_KEY: 'SET_API_KEY',
  SET_USER: 'SET_USER',
  SET_LAST_URL: 'SET_LAST_URL',
  SET_HEADER: 'SET_HEADER',
  SET_BOOKING_URL: 'SET_BOOKING_URL',
  SET_EDIT_BOOKING: 'SET_EDIT_BOOKING',
  SET_INSTANT_BOOKING: 'SET_INSTANT_BOOKING',
  SET_MONTHLY_BOOKING: 'SET_MONTHLY_BOOKING',
  CLEAR_CREATE_BOOKING: 'CLEAR_CREATE_BOOKING',
  SET_CREATE_BOOKING: 'SET_CREATE_BOOKING',
  CLEAR_BOOKING_STATE: 'CLEAR_BOOKING_STATE',
  LOGOUT_FROM_MS: 'LOGOUT_FROM_MS',
  CLEAR_STATE: 'CLEAR_STATE',
};

export default {
  [MUTATIONS.SET_API_KEY](state: State, api_key: string): void {
    state.apiKey = api_key;
  },

  [MUTATIONS.SET_USER](state: State, user: User): void {
    state.user = user;
  },

  [MUTATIONS.SET_LAST_URL](state: State, last_url: string): void {
    state.lastUrl = last_url;
  },

  [MUTATIONS.SET_HEADER](state: State, header: Header): void {
    state.header = header;
  },

  [MUTATIONS.SET_BOOKING_URL](state: State, booking_url: string): void {
    state.bookingUrl = booking_url;
  },

  [MUTATIONS.SET_EDIT_BOOKING](state: State, edit_booking: string): void {
    state.editBooking = edit_booking;
  },

  [MUTATIONS.SET_INSTANT_BOOKING](state: State, instant_booking: boolean): void {
    state.instant_booking = instant_booking;
  },

  [MUTATIONS.SET_MONTHLY_BOOKING](state: State, bookings: Booking[]): void {
    state.monthly_bookings = bookings;
  },

  [MUTATIONS.CLEAR_CREATE_BOOKING](state: State): void {
    state.createBooking = {};
  },

  [MUTATIONS.SET_CREATE_BOOKING](state: State, booking: CreateBooking): void {
    state.createBooking = booking;
  },

  [MUTATIONS.CLEAR_BOOKING_STATE](state: State): void {
    state.editBooking = '';
    state.createBooking = {};
    state.instant_booking = false;
  },

  [MUTATIONS.LOGOUT_FROM_MS](state: State): void {
    state.logout_from_ms = true;
  },

  [MUTATIONS.CLEAR_STATE](state: State): void {
    sessionStorage.clear();
    state.apiKey = '';
    state.user = undefined;
    state.createBooking = {};
    state.lastUrl = '';
    state.logout_from_ms = false;
  },
};
